// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_TIMEZONE = "Asia/Kathmandu";
